import React, { FC } from 'react'
import classNamesBind from 'classnames/bind'
import css from './styles.module.scss'
import ColorIcon from '@dashboard/components/ColorIcon'
import Button from '@dashboard/components/Button'

interface OwnProps {
  pageName: string
}

const classNames = classNamesBind.bind(css)
const hideUpgradeBanner = [
  'profile',
  'upgrade',
  'ceInstalled',
  'ceUninstalled',
  'onboarding',
  'settings',
]

const UpgradeBanner: FC<OwnProps> = ({ pageName }: OwnProps) => {
  if (hideUpgradeBanner.includes(pageName)) return null

  return (
    <div
      className={classNames('container', {
        hideOnMobileAssessment: pageName === 'assessment',
      })}
    >
      <ColorIcon icon="simple-lock" width={16} discType="Id" />
      <div className={classNames('text')}>Ready for more?</div>
      <Button noMargin color="#ffb727" to="/app/upgrade">
        Upgrade Account
      </Button>
    </div>
  )
}

export default UpgradeBanner
